// Brand config — sourced from the API on app init so rebranding is a
// SQL update (system_config at hospital_id=0) rather than a rebuild.
//
// Env vars (VUE_APP_BRAND_*) act as first-paint fallbacks so the app
// doesn't flash "undefined" while the fetch is in flight. Once the
// fetch resolves, values are patched in place; all components using
// `brand.name` etc. re-render via Vue's reactivity.

import { reactive } from "vue";
import axios from "axios";

const brand = reactive({
    // Query string keys the CDN cache per brand — without it Cloudflare
    // keeps serving whichever brand's logo it cached first.
    logo:             "logos/hospital_managemnt_logo.png?b=" + (process.env.VUE_APP_BRAND || "craft"),
    name:             process.env.VUE_APP_BRAND_NAME     || "CRAFT CARE",
    tagline:          process.env.VUE_APP_BRAND_TAGLINE  || "Digitizing Care Where It Matters Most",
    showOrgSignup:    (process.env.VUE_APP_BRAND_SIGNUP  || "true").toLowerCase() !== "false",
    loaded:           false,
});

export async function initBrand() {
    try {
        const base = process.env.VUE_APP_BASE_URL_HMS;
        if (!base) return;
        const url = base + "/index.php?function=getPublicBrand";
        const { data } = await axios.post(url);
        if (data && data.success && data.data) {
            brand.name          = data.data.name          || brand.name;
            brand.tagline       = data.data.tagline       || brand.tagline;
            brand.showOrgSignup = !!data.data.signup_enabled;
            brand.loaded        = true;
        }
    } catch (e) {
        // Silent fallback — keep env-var defaults if the API is unreachable.
        // eslint-disable-next-line no-console
        console.warn("[brand] init failed, using build-time fallback:", e.message);
    }
}

export default brand;
